import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'yellove_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <span className="text-2xl flex-shrink-0">🍪</span>
        <p className="text-sm text-gray-600 flex-1 leading-relaxed">
          We use cookies to improve your experience.{' '}
          <Link to="/privacy-policy" className="text-brand-dark underline underline-offset-2 hover:text-brand-yellow transition-colors">
            Learn more
          </Link>
        </p>
        <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
          <button onClick={reject}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors">
            Reject
          </button>
          <button onClick={accept}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl bg-brand-yellow text-brand-dark text-sm font-bold hover:opacity-90 transition-opacity">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
